import axiosInstance from '../common/interceptor/axios-interceptor'
import Config from '../config/config'
const BASE_URL = Config.getBaseUrl()

export const loginAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}sign-in`,
    data: data,
  })
}

export const createAccountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}create-account`,
    data: data,
  })
}

export const sendOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}send-otp`,
    data: data,
    authRequired: true,
  })
}

export const sendUnAuthOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/send-otp`,
    data: data,
  })
}

export const validateUnAuthOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/verify-otp`,
    data: data,
  })
}

export const validateOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}verify-otp`,
    data: data,
    authRequired: true,
  })
}

export const forgotPasswordAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/forgot-password`,
    data: data,
  })
}

export const getPharmacyStoreAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-all-branches`,
    data: data,
    authRequired: true,
  })
}
export const getDeliveryPartnersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-delivery-partners`,
    data: data,
    authRequired: true,
  })
}
export const updateDeliveryPartnerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-delivery-partner`,
    data: data,
    authRequired: true,
  })
}
export const addDeliveryPartnerZoneAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-delivery-partner-zone`,
    data: data,
    authRequired: true,
  })
}
export const addDeliveryPartnerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-delivery-partner`,
    data: data,
    authRequired: true,
  })
}

export const updatePharmacyStoreAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-branch-active-status`,
    data: data,
    authRequired: true,
  })
}

export const getAllCustomersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-all-online-customers`,
    data: data,
    authRequired: true,
  })
}

export const updateCustomersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-customer-active-status`,
    data: data,
    authRequired: true,
  })
}

export const getAllSupplierAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-all-suppliers`,
    data: data,
    authRequired: true,
  })
}

export const updateSupplierAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}create-or-update-supplier`,
    data: data,
    authRequired: true,
  })
}

export const addUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}add-user`,
    data: data,
    authRequired: true,
  })
}

export const addUpdateUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}add-or-update-crm-user`,
    data: data,
    authRequired: true,
  })
}

export const updateUserActiveStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-crm-user-active-status`,
    data: data,
    authRequired: true,
  })
}

export const getUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-all-crm-users`,
    data: data,
    authRequired: true,
  })
}

export const getAllPharmacyRequestAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-all-pharmacy-requests`,
    data: data,
    authRequired: true,
  })
}

export const updatePharmacyRequestAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-pharmacy-request`,
    data: data,
    authRequired: true,
  })
}

export const getSearchSuggestionsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-search-suggestions`,
    data: data,
    authRequired: true,
  })
}

export const getSearchDataAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-search-data`,
    data: data,
    authRequired: true,
  })
}

export const getAllProductAPI = async (data, params) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-new-products`,
    data: data,
    params,
    authRequired: true,
  })
}

export const upsertProductAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-or-add-new-product`,
    data: data,
    authRequired: true,
  })
}

export const getMedicalCategoryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-product-categories`,
    data: data,
    authRequired: true,
  })
}

export const getPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-branch-all-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const getUniversalCustomerPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-universal-customer-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const updateUniversalCustomerPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-universal-customer-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const updateUniversalPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-universal-branch-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const upsertIndividualPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}add-or-update-individual-branch-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const deleteIndividualPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}delete-individual-branch-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const getCommisionEarningsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-branch-all-commission-earnings`,
    data: data,
    authRequired: true,
  })
}

export const updateUniversalCommisionEarningAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-universal-branch-commission-earning`,
    data: data,
    authRequired: true,
  })
}

export const upsertIndividualCommisionEarningAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}add-or-update-individual-branch-commission-earning`,
    data: data,
    authRequired: true,
  })
}

export const deleteIndividualCommissionEarningAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}delete-individual-branch-commission-earning`,
    data: data,
    authRequired: true,
  })
}

export const getQueriesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-queries`,
    data: data,
    authRequired: true,
  })
}

export const getQueryDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-query-details`,
    data: data,
    authRequired: true,
  })
}

export const resolveQueryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}resolve-query`,
    data: data,
    authRequired: true,
  })
}

export const getConsumerOrdersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-consumer-orders`,
    data: data,
    authRequired: true,
  })
}

export const getHomeDataAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-home-screen-dashboard`,
    data: data,
    authRequired: true,
  })
}

export const getPharmacyInventoryAPI = async (data, params) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-pharmacy-inventory`,
    data: data,
    params,
    authRequired: true,
  })
}

export const updatePharmacyInventoryItemAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-pharmacy-inventory-item`,
    data: data,
    authRequired: true,
  })
}

export const updateQueryStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-query-status`,
    data: data,
    authRequired: true,
  })
}

export const assignQueryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}assign-query`,
    data: data,
    authRequired: true,
  })
}

export const updateQueryNotesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-query-notes`,
    data: data,
    authRequired: true,
  })
}
export const downloadProductCatalogCSVAPI = async (params, config = {}) => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}download-product-catalog-csv`,
    params: params,
    authRequired: true,
    ...config,
  })
}
export const bulkAddProductReceivingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}bulk-add-product-receiving`,
    data: data,
    authRequired: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
